import './mail-attachment.ajscss';

import { IEpticaExctractAttachment } from '@commons/history/history-mail/models/eptica-extract';
import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './mail-attachment.template.html';

class MailAttachmentCtrl implements IComponentController {
  attachments: IEpticaExctractAttachment[];
  addAttachment: Function;
  removeAttachment: Function;

  $onInit() {}

  sizeToStr(bytes: number): string {
    if (bytes === 0) {
      return '0.00 o';
    }
    const e = Math.floor(Math.log(bytes) / Math.log(1024));
    // RTFM : 1024 -- > '1 Ko'   , 1024000 --> '1 Mo'
    return `${(bytes / Math.pow(1024, e)).toFixed(2)} ${' KMGTP'.charAt(e)}o`;
  }

  formatExtension(_elem): string {
    let extension = _elem.title.split('.');
    if (extension.length === 1 || (extension[0] === '' && extension.length === 2)) {
      return '';
    }
    return extension.pop() + ' -';
  }

  removeExtension(_elem): string {
    let lastDotPosition = _elem.title.lastIndexOf('.');
    let firstDotPosition = _elem.title.startsWith('.');
    if (lastDotPosition === -1 || firstDotPosition === true) return _elem.title;
    else return _elem.title.substr(0, lastDotPosition);
  }

  formatSize(_elem): string {
    let _ret = '';
    if (!!_elem.file && !!_elem.file.size) {
      _ret = ` (${this.formatExtension(_elem)} ${this.sizeToStr(_elem.file.size)})`;
    }
    return this.removeExtension(_elem) + _ret;
  }
}

export class MailAttachment implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    attachments: '<',
    addAttachment: '&',
    removeAttachment: '&',
  };
  controller = [MailAttachmentCtrl];
}

export default 'contactMailAttachment';
